const variantMap = JSON.parse(document.getElementById('variant-map').textContent);

document.addEventListener('change', (event) => {
  const productForm = event.target.closest('form[action*="/cart/add"]');
  
  if (!productForm) return;

  const currentVariantId = productForm.querySelector('input[name="id"]').value;
  const variant = variantMap[currentVariantId];
  if (!variant) return;

  const stockInfoDiv = document.querySelector('#custom-stock-info');
  
  if (!stockInfoDiv) return;

  if (!variant.available) {
    
    stockInfoDiv.innerHTML =
      '<p>Artikel zurzeit nur bestellbar - Bitte wenden Sie sich direkt an uns unter</p>' +
      '<a href="/pages/contact" style="color: #b9d44a" target="_blank">Kontakt</a>. Vielen Dank!<br>';
  } else if (variant.inventory_quantity === 0) {
    stockInfoDiv.innerHTML = `<p>- Lieferzeit 3-4 Wochen</p>`;
  } else {
    stockInfoDiv.innerHTML = `<p>- Lieferzeit 1-2 Tage</p>`;
  }
});
